import React, { useState } from "react";
import "./CourseSignupStyles.scss";
import { Link } from "react-router-dom";

export default function KartraForm() {
  const [isChecked, setIsChecked] = useState(false);
  const handleSubmit = (e) => {
    if (isChecked) return;
    e.preventDefault(); // stop form from actually submitting
    const formData = new FormData(e.target); // get all form fields
    const entries = Object.fromEntries(formData.entries()); // convert to object
    console.log(entries); // ✅ logs { first_name: "John", email: "john@example.com", ... }
  };

  return (
    <div className='course-form__container'>
      <h3>Breathwork - Online course</h3>
      <h5>Coming soon</h5>
      <Link className='course-form__link' to='/breathwork'>
        Read more...
      </Link>
      {/* <form
        method='post'
        action='https://app.kartra.com/process/add_lead/KeniS6FjIoZa'
        target='_top'
        data-kt-type='optin'
        data-kt-value='KeniS6FjIoZa'
        data-kt-owner='BrWMyW5g'
        acceptCharset='UTF-8'
        className='course-form'
        onSubmit={handleSubmit}
      > */}
      {/* <input
          type='text'
          name='aaddress_url'
          style={{ display: "none" }}
          defaultValue=''
          aria-hidden='true'
          tabIndex={-1}
        /> */}

      {/* <input
          type='text'
          className='js_kartra_santitation'
          data-santitation-type='front_name'
          placeholder='First name...'
          name='first_name'
          defaultValue=''
        /> */}

      {/* <input type='text' data-santitation-type='email' placeholder='Email...' name='email' defaultValue='' /> */}

      {/* <div className='js_gdpr_communications'>
            <input name='gdpr_communications' type='checkbox' value='1' />
            &nbsp;<span className='course-form__label'>I would like to receive future communications</span>
          </div> */}
      {/* <div className='js_gdpr_terms'>
            <input
              checked={isChecked}
              onChange={(e) => setIsChecked(e.target.checked)}
              name='gdpr_terms'
              type='checkbox'
              className='js_gdpr_terms_check'
              value='1'
            />
            &nbsp;<span className='course-form__label'>I agree to the GDPR &amp; CCPA Terms &amp; Conditions</span>
          </div> */}

      {/* <button
          disabled={!isChecked}
          className='special-btn'
          type='submit'
          onClick={(e) => {
            const element = e.currentTarget;
            element.form.submit();
            element.setAttribute("disabled", true);
            setTimeout(() => {
              element.removeAttribute("disabled");
            }, 1000);
          }}
        >
          Submit
        </button> */}
      {/* </form> */}
    </div>
  );
}
